export const mappingStatuses = ['mapped', 'unmapped', 'auto', 'dismissed', 'deleted']
export const defaultSelectedMappingStatuses = ['unmapped']
